<template lang="pug">
  .ugc-with-reviews.container
    .row
      h2.ugc-title.title.f-secondary.text-color-2.xs-f-grande.lg-f-xgrande.max-at-tweak.text-center {{ title }}

    .row.centerRow
      .masonry-wrap.md-12.md-hide.lg-hide
        .css-grid-masonry(:style="masonryStyle" v-show="images && images.length")
          template(v-for="(image, index) in processedImages")
            .item.col--1x(v-if="!image" :key="index")
            .item.col--2x(v-else :key="index")
              img(:src="image.url" :alt="image.alt_text" :style="imageStyle" tabindex="0")

      .absolute-wrap.pa-0.ma-0.xs-hide.sm-hide
        .wide-centered
          .masonry-wrap
            .css-grid-masonry.left-masonry(:style="halfMasonryStyle" v-show="firstHalfImages && firstHalfImages.length")
              template(v-for="(image, index) in firstHalfImages")
                .item.col--1x(v-if="!image" :key="index")
                .item.col--2x(v-else :key="index")
                  img(:src="image.url" :alt="image.alt_text" :style="imageStyle" tabindex="0")

          .simple-carousel-wrap
            simple-review-quotes-carousel(v-bind="reviewQuotesConfig")

          .masonry-wrap
            .css-grid-masonry.right-masonry(:style="halfMasonryStyle" v-show="secondHalfImages && secondHalfImages.length")
              template(v-for="(image, index) in secondHalfImages")
                .item.col--1x(v-if="!image" :key="index")
                .item.col--2x(v-else :key="index")
                  img(:src="image.url" :alt="image.alt_text" :style="imageStyle" tabindex="0")
  
    .row.md-hide.lg-hide.bottomRow
      .simple-carousel-wrap
        simple-review-quotes-carousel.xs-4(v-bind="reviewQuotesConfig" :solid-cta-button="false")
</template>

<script>
import { mapState } from 'vuex';
import LazyComponent from "@components/LazyComponent";
import SimpleReviewQuotesCarousel from "@components/SimpleReviewQuotesCarousel";

export default {
  name: "UgcWithReviews",
  components: {
    LazyComponent,
    SimpleReviewQuotesCarousel,
  },

  props: {
    images: {
      type: Array,
      required: true
    },

    title: {
      type: String,
      default: ''
    },

    reviewQuotesConfig: {
      type: Object,
      default() {
        return {
          ctaClickEventName: '',
          cta: {
            url: '',
            text: '',
          },
          quotes: []
        };
      },
    },
  },

  data() {
    return {
      columns: 6,
      padding: 10,
      itemWidth: 105,
    };
  },

  computed: {
    ...mapState('global', ['windowData']),

    imageStyle() {
      return {
        width: `${this.itemWidth + 12}px`
      };
    },
    visibleColumns() {
      let potentialWidth = (this.itemWidth *  this.columns) + (this.columns * 2 * this.padding);

      if (this.windowData.width >= potentialWidth) {
        return this.columns;
      } else {
        return Math.floor(this.windowData.width / (potentialWidth / this.columns));
      }
    },
    halfwayThroughImagesLength() {
      return Math.floor((this.images || []).length / 2);
    },
    processedImages() {
      return this.computeImageArray(this.visibleColumns, true, 0);
    },
    firstHalfImages() {
      return this.computeImageArray(this.columns / 2, false);
    },
    secondHalfImages() {
      return this.computeImageArray(this.columns / 2, false, this.halfwayThroughImagesLength);
    },
    masonryStyle() {
      return this.computeMasonryStyle(this.visibleColumns);
    },
    halfMasonryStyle() {
      return this.computeMasonryStyle(this.visibleColumns / 2);
    },
  },
  methods: {
    computeMasonryStyle(columns) {
      return {
        width: `${(this.itemWidth * columns) + (columns * 2 * this.padding)}px`,
        "grid-gap": `${this.padding}px`,
      };
    },
    computeImageArray(columns, shortColumnFirst, lengthOffset, maxItemsCount) {

      let newImages = [];

      if (!this.images || !this.images.length) {
        return newImages;
      }
      
      if (maxItemsCount === undefined) {
        maxItemsCount = this.images.length;
      }

      if (lengthOffset === undefined) {
        lengthOffset = 0;
      }

      shortColumnFirst = shortColumnFirst !== undefined && shortColumnFirst;

      let index = 0;
      let adjustedLength = 0;

      while (index < columns) {
        if (shortColumnFirst) {
          adjustedLength += index % 2 === 0 ? 2 : 3;
        } else {
          adjustedLength += index % 2 === 0 ? 3 : 2;
        }
        index++;
      }

      let additionOffset =  shortColumnFirst ? Math.ceil(columns / 2) : Math.floor(columns / 2);

      newImages = [];

      index = 0;

      let selectedImages = this.images.slice(lengthOffset, Math.min(maxItemsCount, lengthOffset + adjustedLength));

      newImages = [];

      while (index < additionOffset) {
        if (shortColumnFirst) {
          newImages.push(null);
        }

        newImages.push(selectedImages[index]);
        
        if (!shortColumnFirst) {
          newImages.push(null);
        }
        index++;
      }

      newImages = newImages.concat(selectedImages.slice(index));

      return newImages;
    }
  }
};
</script>

<style lang="stylus">
.ugc-with-reviews
  padding 2em 0
  overflow hidden
  margin 2em auto
  max-width 1300px

  @media mq-mobile
    padding-bottom 30px
    overflow hidden

  .css-grid-masonry
    display grid
    grid-template-columns repeat( auto-fill, 117px )
    grid-auto-rows 54px
    margin 0px 40px

  .centerRow
    height 374px

    .masonry-wrap
      height 100%
      width 100%
      padding-left 50%
      position relative

      .css-grid-masonry
        transform translateX(-50%)
        margin 0px
        margin-left 2px

    .wide-centered
      display flex
      justify-content center
      width 1350px
      margin-left 50%
      transform translateX(-50%)

      .simple-carousel-wrap
        max-width 450px
        background-color ui-color-3
        padding 0px 20px
        margin 18px 0px

        .simple-review-quotes-carousel
          position absolute
          top 50%
          transform translateY(-50%)

      .masonry-wrap
        padding-left 0%

        .css-grid-masonry
          transform translateX(0%)

      .left-masonry
        float right
        margin-right 40px

      .right-masonry
        float left
        margin-left 40px

  .bottomRow
    padding 0px 11%
    margin 6% 0px
    
    .simple-carousel-wrap
      height 100%

  .middle-carousel
    width 364px
  
  .leftMasonry
    float left

  .rightMasonry
    float right

  .ugc-title
    margin-bottom 40px

    @media mq-table
      text-align unset

      @media mq-mobile
        text-align unset

  .masonry-wrap
    .col--1x
      grid-row-end span 1
    
    .col--2x
      grid-row-end span 2
    
    .item
      img
        width 100%
</style>
